import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Home",
    component: () => import("@v/pc"),
  },
  {
    path: "/about",
    name: "About",
    component: () => import("@v/pc/children/about.vue"),
  },
  {
    path: "/product",
    name: "Product",
    component: () => import("@v/pc/children/product.vue"),
  },
  {
    path: "/mobile",
    name: "Mobile",
    component: () => import("@v/mobile"),
  },
  {
    path: "/mobile/about",
    name: "MobileAbout",
    component: () => import("@v/mobile/children/about.vue"),
  },
];

const router = new VueRouter({
  routes,
});

export default router;
